import React, { memo } from "react";

import {
  Button,
  HStack,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Text,
  VStack,
} from "@chakra-ui/react";
import colors from "app/colors";
import { EmailIcon } from "modules/icons";
import { useOverlay } from "modules/providers/overlay-provider";

const EmailInfoModal = () => {
  const { closeModal } = useOverlay();
  return (
    <Modal isOpen onClose={closeModal} size="xs" isCentered>
      <ModalOverlay />
      <ModalContent borderRadius={16}>
        <ModalBody pb={4}>
          <VStack>
            <EmailIcon fill={colors.darkBlue} boxSize={54} />
            <Text fontSize={16} fontWeight={700}>
              Email to Synco Addresses
            </Text>
            <Text fontSize={13} textAlign="center">
              Use these email addresses to forward emails into Synco. Click the
              copy icon next to the address to copy it to your clipboard, and
              you're ready to go!
            </Text>
            <HStack>
              <Button height={8} w={28} onClick={closeModal}>
                Got it!
              </Button>
            </HStack>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default memo(EmailInfoModal);
